import { routeTypes } from "~/hec/builder/blocks/components/cta/utils";
import type { FeatureLinkTarget } from "~/hec/components/molecules/feature-link/types";

import { useIsLegacyHref } from "./useIsLegacyHref";

/**
 * Same ownership check `HybridLink` uses: an INTERNAL url on an SFRA-owned path
 * is sent as a full page load (routeType SFRA), so there is no "Is SFRA" input.
 * Lives here, not in `FeatureLink`, because a molecule must not read router
 * state; organisms call it and pass the result down.
 */
export function useFeatureLinkTarget(
  target?: FeatureLinkTarget,
): FeatureLinkTarget | undefined {
  const isLegacy = useIsLegacyHref(
    target?.routeType === routeTypes.INTERNAL ? target.url : undefined,
  );
  return target && isLegacy
    ? { ...target, routeType: routeTypes.SFRA }
    : target;
}
